import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function SwipeOut(props) {
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="SwipeOutIcon">
                <path d="M42.25,1h-23a1.44,1.44,0,0,0-1.44,1.44V16.81h2.88V3.88H40.81V44.13H20.69V31.19H17.81V45.56A1.44,1.44,0,0,0,19.25,47h23a1.44,1.44,0,0,0,1.44-1.44V2.44A1.44,1.44,0,0,0,42.25,1Z" />
                <path d="M15.39,16.39l-2-2L4.73,23a1.45,1.45,0,0,0,0,2l8.63,8.62,2-2L9.22,25.44H33.06V22.56H9.22Z" />
            </g>
        </SvgIcon>
    );
}

export default SwipeOut;